export default function ContactPage() {
  return (
    <div className="static-page">
      <h2>Contact Us</h2>
      <p>
        Have questions, feedback, or need support? We’d love to hear from you.
      </p>
      <p>
        Email us at <a href="mailto:support@taskmanagerapp.com">support@taskmanagerapp.com</a> or reach out via our GitHub repository for technical issues.
      </p>
      <p>
        We typically respond within 24–48 hours. Your feedback helps us improve TaskManager App for everyone.
      </p>
    </div>
  );
}